import { Injectable } from '@angular/core';
import { TokenJWT } from 'src/app/core/models/token/token-jwt';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StateAccountService {

  constructor() { 
  }

  /**
   * Controlla lo stato dell'accoount (se è parziale lo trasforma in attivo)
   */
  async upgradeStateAccount(token: TokenJWT){
    try {
      let response = await fetch(
        environment.apiUrl + environment.apiVersion + `/accounts/state/read`,
        {
          headers: { Authorization: token.toString() },
          method: 'GET',
        }
      );

      let data = await response.json();

      if (!response.ok) {
        throw new Error(`${data.description}`);
      }

      let idStato = data.body.idStato

      // Se si tratta di un account parziale lo aggiorno in attivo
      if(idStato == 3){
        const params = JSON.stringify({ IDStato: 1 })

        try {
          fetch(
            environment.apiUrl +
              environment.apiVersion +
              '/accounts/state/update',
            {
              headers: { Authorization: token!.toString() },
              body: params,
              method: 'POST',
            }
          )
        } catch (error) {
          console.error(error);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
}
